// Generated by CoffeeScript 2.7.0
var ActionsSelect;

import Popover from 'trunks/vue/admin/components/libs/popover.js';

import ChipInput from 'trunks/vue/admin/components/libs/chip_input.js';

import GroupOptions from 'trunks/vue/admin/components/libs/group_options.js';

export default ActionsSelect = Vue.extend({
  components: {
    "Popover": Popover,
    "chip-input": ChipInput,
    "group-options": GroupOptions
  },
  template: `<Popover position="bottom"
         :caret='false'
         :blockContent='true'
         :manualToggle='true'
         @triggerClicked='triggerClicked'
         ref='popoverVm'>
  <template slot='trigger'>
    <chip-input :chips='selectedItems'
                placeholder='请选择权限'
                @chipClicked='unselect'
                ref='chipInput' />
    <i class="slp-caret-down"></i>
  </template>
  <template slot='content'>
    <group-options :groupedOptions='groupedOptions'
                   :multiple='true'
                   @valueChanged='valueChangedFunc'
                   ref='groupedOptionsRef'>
      <template slot='option-item-template' slot-scope='{ option }'>
        <div class='content'>
          <span>{{ option.name }}</span>
        </div>
        <i class='tip' :class="getSelected(option) ? 'slp-check' : 'slp-empty'"></i>
      </template>
    </group-options>
  </template>
</Popover>`,
  props: {
    options: {
      type: Array
    },
    initialSelectedItems: {
      type: Array
    }
  },
  data: function() {
    return {
      selectedItems: this.initialSelectedItems
    };
  },
  computed: {
    groupedOptions: function() {
      return [
        {
          allow_clear: true,
          options: this.options
        }
      ];
    }
  },
  methods: {
    unselect: function(option) {
      option._selected = !option._selected;
      return this.valueChangedFunc(null, option);
    },
    valueChangedFunc: function(_vm, option) {
      var unselectedItem;
      this.selectedItems = option._selected ? _.union(this.selectedItems, [option]) : (unselectedItem = _.find(this.selectedItems, function(item) {
        return item.id === option.id;
      }), _.without(this.selectedItems, unselectedItem));
      return this.$emit('valueChanged', this.selectedItems);
    },
    triggerClicked: function() {
      return this.$refs.popoverVm.open();
    },
    getSelected: function(option) {
      return _.some(this.selectedItems, function(item) {
        return item.id === option.id;
      });
    }
  }
});
